import $ from 'jquery';

export default function accordion() {
  const block = $('.section--accordion');
  const item = block.find('.section__item');
  const head = item.find('.section__head');

  head.on('click', function () {
    const content = $(this).closest('.section__item').find('.section__content');

    $(this).closest('.section__item').toggleClass('is-active');
    content.slideToggle(250);
  });
}
